import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actionCreators } from '../store/actions/accessory'
import {getComponentDisplayName, constructOutputProps, jsonToComponents} from '../utils'

/**
 * Higher order component for parsing (json) CMS components from to react children
 * @param {Object} options - Initial config options.
 * @param {Array} options.componentWhiteList -
 * Array of components that can be used as children.
 * @param {Array} options.mapInputToOutput -
 * Array of input key output key mappings for multiple dynamic component areas.
 * @returns {Function} The configured higher order component,
 * which in turn will return a component class.
 */
export default ({
                  componentWhitelist = [],
                  mapInputToOutput = [['components', 'children']],
                  mapInput = comp => comp, // Escape hatch for pending CMS name / props changes
                } = {}) => (Wrapped) => {
  const withDynamicComponents = ({children, ...props}) => (
    <Wrapped
      {...constructOutputProps(
        props,
        mapInputToOutput,
        jsonToComponents(componentWhitelist, mapInput, getComponentDisplayName(Wrapped), {
          children,
        }),
      )} />
  )
  withDynamicComponents.displayName = `withDynamicComponents(${getComponentDisplayName(Wrapped)})`
  
  withDynamicComponents.propTypes = {
    components: PropTypes.array,
    children: PropTypes.array,
  }

  const mapStateToProps = state => ({
    isCountable: state.accessory.isCountable,
    everySixteenAccessories: state.accessory.everySixteenAccessories
  })

  const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch)

  return connect(mapStateToProps, mapDispatchToProps)(withDynamicComponents)
}



// WEBPACK FOOTER //
// ./src/higher-order-components/with-dynamic-components.jsx